function fetchResearchProjectDetailsQuery (id) {
  let variables = { id: id }

  return {
    operationName: 'fetchResearchProjectDetailsQuery',
    query: `
      query fetchResearchProjectDetailsQuery($id: ID!) {
        forschungsprojekt: project(id: $id) {
          organisationseinheit: organisationalUnit {
            _id:id
            _entityName
            _stringRep
            parentOrgaName
          }
          relevantFuerWeitere: hasMultipleOus
          weitereOrganisationseinheiten: additionalOrganisationalUnits {
            _id:id
            _entityName
            _stringRep
            parentOrgaName
          }
          _id: id
          _entityName
          _stringRep
          primaryPublicIdent
          titelDE: titleDe
          titelEN: titleEn
          beschreibungDE: descriptionDe
          beschreibungEN: descriptionEn
          uebergeordnetesProjekt: superordinateProject
          antragsteller: applicants {
            _entityName
            _stringRep: fullName
            fisPersid
            orcid
          }
          sdg {
            _id: id
            _entityName
            _stringRep
            nameDe
            nameEn
          }
          projektleiter: managers {
            startdatum: startDate
            enddatum: endDate
            person {
              _entityName
              _stringRep: fullName
              fisPersid
              orcid
            }
          }
          mitarbeiter: collaborators {
            _entityName
            _stringRep: fullName
            fisPersid
            orcid
          }
          projektBeginn: startDate
          projektEnde: endDate
          externeProjektwebsite: externalProjectWebsite
          foerderung: funding {
            mittelgeber: fundingAgency {
              _stringRep
              _entityName
              finSchluessel: financingKey
            }
            foerderkennzeichen: fundingCode
          }
          publikation: publications {
            _id:id
            _entityName
            _stringRep
            titelPublikation:title
            publikationsTyp:typeDe
            author:authors {
              _stringRep
              _entityName
              name:surname
              vorname:givenName
            }
            herausgeber:editors {
              _stringRep
              _entityName
              name:surname
              vorname:givenName
            }
            verlagsort:place
            veroeffentlichungsJahr:year
            organisationseinheit:organisationalUnit {
              name:titleDe
            }
            weitereOrganisationseinheiten:additionalOrganisationalUnits {
              name:titleDe
            }
            publicPubIdent:identifiers {
              pubIdentTyp:type {
                anmerkung:comment
                kennung:key
              }
              wert:value
            }
            institution:issuingOrganisation
            journal
            verleger:publisher
            journalNummer:issue
            band:volume
            istFinal:validated
            seiteEnde:pageEnd
            seiteStart:pageStart
            serientitel:seriesTitle
            sprache:language
            buchtitel:bookTitle
            validiert:validated
            foerderer:fundingAgencies {
              _entityName
              _stringRep
              name
            }
          }
          verbundprojekt: isJointProject
          sprecherhochschule: spokesperson_ou {
            _entityName
            _stringRep
          }
        }
      }
    `,
    variables
  }
}

export { fetchResearchProjectDetailsQuery }



// WEBPACK FOOTER //
// ./src/graphql/projectDetails.js